import { render, staticRenderFns } from "./global_ad.vue?vue&type=template&id=4fb340d3&"
import script from "./global_ad.vue?vue&type=script&lang=js&"
export * from "./global_ad.vue?vue&type=script&lang=js&"
import style0 from "./global_ad.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/promotion/global_ad.vue
// module id = null
// module chunks = 